import { Directive, ElementRef, inject, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { Basket } from '@df/session/api/basket/basket';
import { UiComponent } from '@df/ui/ui.component';

@Directive()
export abstract class AbstractBasketComponent<TBasket extends Basket = Basket> extends UiComponent implements OnInit {
    readonly app = inject(App);
    protected elementRef = inject(ElementRef);
    protected basket = inject(Basket) as TBasket;

    override ngOnInit(): void {
        this.subscriptions.add(this.basket.subscribe(() => this.detectChanges()));
        super.ngOnInit();
    }
}
